module.exports = __webpack_public_path__ + "img/presale_open_bulldroids.2c722a65.gif";